import kamala from '../../kamala'
import Timeline from './Timeline'
import TimelineItem from './TimelineItem'

const KTimelineFamily = {
  install: function (Vue) {
    kamala(Vue)
    Vue.component(Timeline.name, Timeline)
    Vue.component(TimelineItem.name, TimelineItem)
  },
  KTimeline: Timeline,
  KTimelineItem: TimelineItem,
}

export { Timeline, TimelineItem }

export default KTimelineFamily
